export default __webpack_public_path__ + "static/media/placeholder_business03-fr-web.c390a08b.png";